// @flow
import { THEMATIC } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_COMMON_THEMATIC } from 'Utils/request/requestDictionary';
import { addTranslationKeys } from 'Src/i18n';

declare type CMSProps = {
  title: string,
  items: Array<{
    mediaUrl: string,
    link?: string,
    itemTitle: string,
    isExclusiveCollection: boolean,
  }>,
};

type GQLProps = {
  config: CMSContent,
};

export const thematicResolver = {
  name: THEMATIC,
  resolve: (appContext: AppContext): Promise<GQLProps> => {
    const query = `query {
      config {
        common {
          next
          previous
        }
      }
    }`;

    return graphQLClient
      .runQuery(query, appContext, { requestName: LINE_COMMON_THEMATIC })
      .then(data => {
        addTranslationKeys(data.config);
        return data;
      });
  },
};
